import React, { useState } from "react";
import { Card, Container } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { IoDocumentTextOutline } from "react-icons/io5";

const FacebookTopics = () => {
    // Dummy Questions
    const questions = [
        // { question: "Get started with Facebook Connection", slug: "facebook-connection" },
        { question: "How to connect Instagram Account", slug: "instagram-connection" },
        { question: "How to auto-reply to message on Facebook/Instagram chat", slug: "auto-reply-message" },
        { question: "How to auto-reply to comments on Facebook/Instagram posts", slug: "auto-reply-comments" },
        // { question: "How to auto-reply to Instagram story replies", slug: "auto-reply-story-replies" },
        // { question: "How to auto-reply to Instagram Story Mention", slug: "auto-reply-story-mention" },
        // { question: "How to set up Conversation starters?", slug: "conversation-starters" },
        // { question: "How to set up bot Persistent Menu?", slug: "bot-persistent-menu" },
    ];


    // State for Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const questionsPerPage = 10;

    // Calculate total pages
    const totalPages = Math.ceil(questions.length / questionsPerPage);

    // Calculate displayed questions for the current page
    const indexOfLastQuestion = currentPage * questionsPerPage;
    const indexOfFirstQuestion = indexOfLastQuestion - questionsPerPage;
    const currentQuestions = questions.slice(indexOfFirstQuestion, indexOfLastQuestion);

    // Handle pagination
    const handleClick = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <div>
            <div id="content-page" className="content-inner">
                <Card className="position-relative inner-page-bg bg-primary" style={{ height: "150px" }}>
                    <div className="inner-page-title d-flex justify-content-between align-items-center faq-header ">
                        <div>
                            <h3 className="text-white">Get Started with documention</h3>
                            <p className="text-white">Manage frequently asked questions.</p>
                        </div>
                    </div>
                </Card>
                <Container id="faqAccordion">
                    <Card>
                        {/* <Card.Header className=" d-flex justify-content-between rounded border-bottom-0">
                            <div className="header-title">
                                <h4 className="card-title">Frequently Asked Questions</h4>
                            </div>
                        </Card.Header> */}
                        <Card.Body className='pt-0'>
                            {/* Display Questions */}
                            <ul className="list-group p-4">
                                {currentQuestions.map(({ question, slug }, index) => (
                                    <Card.Header
                                        key={index}
                                        className="d-flex jutify-content-between rounded border-bottom-0 bg-white m-1"
                                    >
                                        <div className="header-title d-flex jutify-content-center align-item-center">
                                            <IoDocumentTextOutline fontSize={20} color="red" />
                                            <Link
                                                to={`/pages/documention/facebook/${slug}`}
                                                className="card-title text-decoration-none text-primary ps-2"
                                            >
                                                {question}
                                            </Link>
                                        </div>
                                    </Card.Header>
                                ))}
                            </ul>

                            {/* Pagination */}
                            <nav aria-label="Page navigation example" className="mt-4">
                                <ul className="pagination mb-0">
                                    <li className={`page-item ${currentPage === 1 && "disabled"}`}>
                                        <Link
                                            className="page-link"
                                            to="#"
                                            onClick={() => handleClick(currentPage - 1)}
                                        >
                                            Previous
                                        </Link>
                                    </li>
                                    {[...Array(totalPages).keys()].map((_, index) => (
                                        <li
                                            key={index}
                                            className={`page-item ${currentPage === index + 1 && "active"}`}
                                        >
                                            <Link
                                                className="page-link"
                                                to="#"
                                                onClick={() => handleClick(index + 1)}
                                            >
                                                {index + 1}
                                            </Link>
                                        </li>
                                    ))}
                                    <li className={`page-item ${currentPage === totalPages && "disabled"}`}>
                                        <Link
                                            className="page-link"
                                            to="#"
                                            onClick={() => handleClick(currentPage + 1)}
                                        >
                                            Next
                                        </Link>
                                    </li>
                                </ul>
                            </nav>
                        </Card.Body>
                    </Card>
                </Container>
            </div>
        </div>
    );
};

export default FacebookTopics;
